module.exports = __webpack_public_path__ + "static/media/car_warranty_desktop.7fa3ec30.svg";